/* eslint-disable radix */
/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { CheckBox } from '../CheckBox';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/close-material.svg';
import { ReactComponent as RadioInnerIcon } from '../../../../assets/svg/radio-inner-icon.svg';
import { ReactComponent as RadioOuterIcon } from '../../../../assets/svg/radio-outer-icon.svg';

class ExportTypeState {
  @observable showPopup = false;

  defaultPopupValue = {
    title: '',
    actionBtnText: 'Export',
    defaultPreferenceCheckBox: true,
    callback() {
      console.log('callback');
    },
  };

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val === false) this.popupValues = this.defaultPopupValue;
  };

  @action
  setPopupValues = val => {
    this.popupValues = { ...this.popupValues, ...val };
  };
}
const exportTypeState = new ExportTypeState();

const ExportLeadsTypePopup = observer(props => {
  const [exportType, setExportType] = React.useState('lead');
  const [saveDefault, setSaveDefault] = React.useState(false);

  const setLeadTypeChange = (e, val) => {
    console.log('val ', val);
    setExportType(val);
  };
  const confirmClick = () => {
    // debugger;
    exportTypeState.popupValues.callback(exportType, saveDefault);
    exportTypeState.setShowPopup(false);
  };

  React.useEffect(() => {
    setExportType('lead');
    setSaveDefault(false);
  }, [exportTypeState.showPopup]);

  const { popupValues } = exportTypeState;
  const { defaultPreferenceCheckBox = true } = popupValues || {};

  return exportTypeState.showPopup ? (
    <>
      <div className="export-type-popup common-popup">
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => exportTypeState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>
          {exportTypeState.popupValues.title && (
            <div className="title">
              Export to {exportTypeState.popupValues.title}
            </div>
          )}
          <div className="popup-content-wrap">
            <div className="export-content-title">
              How to Export these contacts
              {exportTypeState.popupValues.title && (
                <> to {exportTypeState.popupValues.title}</>
              )}
              ?
            </div>
            <div className="export-type-wrap email-deliver">
              <div className="radio-btn-wrap">
                <div className="radio-wrapper">
                  <div
                    className={`radio-item${
                      exportType === 'lead' ? ' selected' : ''
                    }`}
                    onClick={e => setLeadTypeChange(e, 'lead')}
                  >
                    <div className="radio-svg-section">
                      <RadioInnerIcon
                        className="radio-inner"
                        viewBox="0 0 24 24"
                      />
                      <RadioOuterIcon
                        className="radio-outer"
                        viewBox="0 0 24 24"
                      />
                    </div>
                    <div className="radio-text">Export as Lead</div>
                  </div>
                  <div
                    className={`radio-item${
                      exportType === 'contact' ? ' selected' : ''
                    }`}
                    onClick={e => setLeadTypeChange(e, 'contact')}
                  >
                    <div className="radio-svg-section">
                      <RadioInnerIcon
                        className="radio-inner"
                        viewBox="0 0 24 24"
                      />
                      <RadioOuterIcon
                        className="radio-outer"
                        viewBox="0 0 24 24"
                      />
                    </div>
                    <div className="radio-text">Export as Contact</div>
                  </div>
                </div>
              </div>
            </div>
            {defaultPreferenceCheckBox && (
              <div className="export-type-wrap input-section check-box-wrap">
                <div
                  className={`title-checkbox${saveDefault ? ' selected' : ''}`}
                  onClick={e => setSaveDefault(!saveDefault)}
                  style={{ height: '17px' }}
                >
                  <div className="check-box">
                    <CheckBox
                      dymamicClass={saveDefault ? 'selected' : ''}
                      onClick={e => setSaveDefault(!saveDefault)}
                    />
                  </div>
                  <span className="check-box-label">
                    Always use this option
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="popup-action-wrap">
            <div
              className="popup-action-btn"
              onClick={() => exportTypeState.setShowPopup(false)}
            >
              Cancel
            </div>
            <div
              className="popup-action-btn positive-btn"
              onClick={confirmClick}
            >
              {exportTypeState.popupValues.actionBtnText}
            </div>
          </div>
        </div>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => exportTypeState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export { ExportLeadsTypePopup, exportTypeState };
export default ExportLeadsTypePopup;
